import Route from '@ember/routing/route';

export default class DashboardUrlSiteAuditAllChecksShowRoute extends Route {}
